<ng-template #content>
  <ng-content />
</ng-template>

@if (asTag() === 'article') {
  <article
    class="card-container"
    [attr.data-variant]="variant()"
    [attr.data-padding]="padding()"
    [attr.data-gap]="gap()"
    [attr.data-border-radius]="borderRadius()"
    [attr.data-clickable]="clickable()"
    [attr.data-hoverable]="hoverable()"
    [attr.data-disabled]="disabled()"
    [attr.data-selected]="selected()"
    [class.card-clickable]="clickable()"
    [class.card-hoverable]="hoverable()"
    [class.card-selected]="selected()"
    [attr.tabindex]="clickable() && !disabled() ? 0 : null"
    [attr.role]="role()"
    (keydown)="onCardKeydown($event)"
    (click)="onCardClick($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </article>
} @else if (asTag() === 'section') {
  <section
    class="card-container"
    [attr.data-variant]="variant()"
    [attr.data-padding]="padding()"
    [attr.data-gap]="gap()"
    [attr.data-border-radius]="borderRadius()"
    [attr.data-clickable]="clickable()"
    [attr.data-hoverable]="hoverable()"
    [attr.data-disabled]="disabled()"
    [attr.data-selected]="selected()"
    [class.card-clickable]="clickable()"
    [class.card-hoverable]="hoverable()"
    [class.card-selected]="selected()"
    [attr.tabindex]="clickable() && !disabled() ? 0 : null"
    [attr.role]="role()"
    (keydown)="onCardKeydown($event)"
    (click)="onCardClick($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </section>
} @else {
  <div
    class="card-container"
    [attr.data-variant]="variant()"
    [attr.data-padding]="padding()"
    [attr.data-gap]="gap()"
    [attr.data-border-radius]="borderRadius()"
    [attr.data-clickable]="clickable()"
    [attr.data-hoverable]="hoverable()"
    [attr.data-disabled]="disabled()"
    [attr.data-selected]="selected()"
    [class.card-clickable]="clickable()"
    [class.card-hoverable]="hoverable()"
    [class.card-selected]="selected()"
    [attr.tabindex]="clickable() && !disabled() ? 0 : null"
    [attr.role]="role()"
    (keydown)="onCardKeydown($event)"
    (click)="onCardClick($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </div>
}
